import { IntegrationChannelMetadata } from '@modules/integrationsV2/types';
import { getIntegrationChannelsMetadata } from '@modules/integrationsV2/utils';
import {
  IntegrationChannelType,
  IntegrationViewFragment,
} from 'generated/graphql';

export const getAllIntegrationChannelsMetadataDetails = (
  integrations: IntegrationViewFragment[],
) => {
  return integrations.reduce(
    (acc: IntegrationChannelMetadata[], integration) => {
      const channelsMetadata = getIntegrationChannelsMetadata(
        integration.channel.type,
        integration.data,
      );

      const descriptionMap = new Map(
        integration.description?.descriptionMap?.map((description) => [
          description.sourceID,
          description.description,
        ]) ?? [],
      );

      return [
        ...acc,
        ...(channelsMetadata?.map((channelMetadata, index) => ({
          channelID: channelMetadata.id,
          channelName:
            integration.channel.type === IntegrationChannelType.Slack
              ? `#${channelMetadata.name}`
              : channelMetadata.name,
          channelDescription: descriptionMap.get(channelMetadata.id) ?? '',
          integrationID: integration.id,
          workspaceName:
            integration.externalID ||
            `${integration.channel.displayName} ${index + 1}`,
          integrationChannel: integration.channel,
          integrationType: integration.integrationType,
          allChannelDescriptions: integration.description?.descriptionMap ?? [],
        })) ?? []),
      ];
    },
    [],
  );
};
